import cn from 'clsx';
import styles from './styles.css';
import {
  ArticleHeading2,
  ArticleParagraph2,
  IconFunctionalInformationCircle16,
  Image,
  useDeviceType,
} from '@cian/ui-kit';
import { useCreditInfoModal } from 'shared/hooks/useCreditInfoModal';
import { TRealEstateType, TObjectType } from 'shared/types/common/offer';
import { IBankInfo } from 'shared/types/common/bank';
import { IRow } from '../../../../repositories/mortgage-broker-calculator/entities/mortgage_listing/Row';

export interface ITitleProps extends IBankInfo {
  objectType: TObjectType;
  realEstateType: TRealEstateType;
  modalContent?: IRow[];
}

const mapObjectType: Record<TObjectType, string> = {
  house: 'Дом',
  apartments: 'Апартаменты',
  flat: 'Квартира',
  carPlace: 'Машиноместо',
};

const mapRealEstateType: Record<TRealEstateType, string> = {
  newBuilding: 'Новостройка',
  secondary: 'Вторичка',
  houseBuilding: 'Строительство дома',
};

export const Title: React.FC<ITitleProps> = ({ iconPath, objectType, realEstateType, name, modalContent }) => {
  const deviceType = useDeviceType();
  const { handleModalOpen } = useCreditInfoModal();
  const tags = [mapObjectType[objectType], mapRealEstateType[realEstateType]];

  const handlerModal = () => {
    if (!modalContent) {
      return;
    }
    handleModalOpen(modalContent);
  };

  return (
    <header className={cn(styles['wrapper'], styles[deviceType])}>
      <div className={cn(styles['img-wrapper'], styles[deviceType])}>
        <Image
          src={'https://static.cdn-cian.ru/frontend/mortgage-assets/banks/' + iconPath}
          title={name}
          alt={name}
          preloader
        />
      </div>
      <div>
        <ArticleHeading2>{name}</ArticleHeading2>
        <ul className={styles['list']}>
          {tags.map((el, index) => {
            return (
              <li key={index} className={styles['list-item']}>
                <ArticleParagraph2>{el}</ArticleParagraph2>
              </li>
            );
          })}
          {modalContent && (
            <li className={styles['list-item']} onClick={handlerModal}>
              <IconFunctionalInformationCircle16 color={'current_color'} cursor="pointer" />
            </li>
          )}
        </ul>
      </div>
    </header>
  );
};
